import { createRootRoute, Outlet } from '@tanstack/react-router';
import { useEffect } from 'react';
import { TranslationProvider } from '@/context/TranslationContext';
import Header from '@/components/layout/header/Header';
import Footer from '@/components/layout/footer/Footer';
import FloatingContact from '@/components/layout/floating-contact/FloatingContact';
import { Toaster } from 'react-hot-toast';
import VisitorTracker from '@/components/features/tracking/VisitorTracker';
import CookieBanner from '@/components/features/legal/CookieBanner';
import '@/index.scss';
import 'aos/dist/aos.css';
import AOS from 'aos';

export const Route = createRootRoute({
    component: RootComponent,
});

function RootComponent() {
    useEffect(() => {
        AOS.init({
            duration: 1000,
            easing: 'ease-in-out',
            once: true,
            mirror: false,
        });
    }, []);

    return (
        <TranslationProvider>
            <VisitorTracker />
            <CookieBanner />
            <Header />
            <Outlet />
            <Footer />
            <FloatingContact />
            <Toaster position="bottom-right" />
        </TranslationProvider>
    );
}

